import { render, staticRenderFns } from "./MessagePrepare.vue?vue&type=template&id=bca816ee&scoped=true"
import script from "./MessagePrepare.vue?vue&type=script&lang=js"
export * from "./MessagePrepare.vue?vue&type=script&lang=js"
import style0 from "./MessagePrepare.vue?vue&type=style&index=0&id=bca816ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca816ee",
  null
  
)

export default component.exports